const windowWithDefaultValues = {
  addEventListener: (() => {}) as Window['addEventListener'],
  analytics: {},
  btoa: (() => '') as Window['btoa'],
  devicePixelRatio: 1,
  location: {
    assign: () => {},
    href: '',
    origin: '',
    search: '',
  },
  matchMedia: () => ({
    matches: false,
  }),
  open: (() => {}) as Window['open'],
  removeEventListener: (() => {}) as Window['removeEventListener'],
  scrollTo: (() => {}) as Window['scrollTo'],
  screen: {
    orientation: {
      type: '',
    },
  },
  Shopify: {},
  ShopifyAnalytics: {},
  trekkie: {},
};

export const isoWindow =
  typeof window === 'undefined' ? windowWithDefaultValues : window;
